




























import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AddScheme from "./scheme/add-scheme.vue";
import EditScheme from "./scheme/edit-scheme.vue";
class PageSchemeRequest extends PageRequest {
  keyword: string = "";
}

@Component({ components: { AddScheme, EditScheme } })
export default class Scheme extends AbpBase {
  addSchemeModal: boolean = false;
  editSchemeModal: boolean = false;
  pagerequest: PageSchemeRequest = new PageSchemeRequest();
  get list() {
    return this.$store.state.scheme.list;
  }
  get pageSize() {
    return this.$store.state.scheme.pageSize;
  }
  get totalCount() {
    return this.$store.state.scheme.totalCount;
  }
  get currentPage() {
    return this.$store.state.scheme.currentPage;
  }

  pageChange(page: number) {
    this.$store.commit("scheme/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("scheme/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "scheme/getAll",
      data: this.pagerequest,
    });
  }

  create() {
    this.addSchemeModal = true;
  }
  edit() {
    this.editSchemeModal = true;
  }

  async created() {
    this.getpage();
  }

  columns = [
    {
      title: this.L("MeetingTopic"),
      key: "topic",
    },
    {
      title: this.L("AppointmentTime"),
      key: "appointmentTime",
    },
    {
      title: this.L("MeetingMembers"),
      key: "members",
    },
    {
      title: this.L("MeetingOffice"),
      key: "meetingRoom",
    },
    {
      title: this.L("Remark"),
      key: "remark",
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("scheme/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "scheme/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
}
